import React from 'react';
import './ParentGuidelines.css';

const ParentGuidelines = () => {
  const guidelines = [
    "You should not go directly to teacher in the class rooms but contact the Principal.",
    "You should not come with the request for changing the section of your ward. The sections are made in alphabetical order of names of students.",
    "Tuition are not encouraged in the Academy. The teachers pay great attention to the students in the class itself.",
    "You should fill in all details on the first page of the scholar's Diary. The diary should be checked daily by you for remarks, if any, by the teacher and the Principal.",
    "You should pay personal attention to the home work assigned by the teachers.",
    "You should see that your wards are not shabbily dressed. Their uniforms should be neat and tidy. Prescribed house uniform and white uniform should be worn on every Wednesday and Saturday respectively. On other days of the week, prescribed uniform is essential. The students must come smartly dressed up.",
    "You should give your child something to eat during lunch break. Pickles and vegetable with gravy and heavy food should be avoided.",
    "You should check his/her school bag daily to see that our ward has brought all of his/her articles and not of others.",
    "You should write the name of your ward on books, note books school bag, tiffin box etc.",
    "You should pay all the dues in time.",
    "Your ward should reach the school five minutes before the scheduled time. Late comers shall be Sent back to home."
  ];

  return (

    <>
    {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>PARENT-GUIDELINES</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Parent Guidelines</li>
          </ul>
        </div>
      </section>
    <div className="page-wrapper">
      <div className="content-container">
        
        <header className="page-header fade-in">
          <h1>GUIDELINES FOR THE PARENTS</h1>
          <div className="header-line"></div>
        </header>

        <div className="quote-box fade-in-delay-1">
          <p>"A Father is More Than a Hundred School Teachers"</p>
        </div>

        <div className="intro-box fade-in-delay-2">
          <p>
            Your child is the future of the nation. You have entrusted him/her to our care and supervision for molding his/her destiny. Your co-operation with the administration of the Academy is requested. You should please respect the following guidelines religiously:
          </p>
        </div>

        <div className="guidelines-section fade-in-delay-3">
          {guidelines.map((guideline, index) => (
              <div 
              key={index} 
              className="guideline-box"
              style={{animationDelay: `${0.6 + (0.05 * index)}s`}}
              >
              <span className="number">{index + 1}</span>
              <p>{guideline}</p>
            </div>
          ))}
        </div>

        <div className="bicycle-box fade-in-delay-4">
          <p>
            "Kindly note that in education a child rides a bicycle in which the front wheel is the teacher and the back wheel having the hub is the parents, unless the back wheel moves the bicycle will not move."
          </p>
        </div>

        <div className="warning-box fade-in-delay-5">
          <h2>"Delays Are Dangerous"</h2>
        </div>

      </div>
    </div>
          </>
  );
};

export default ParentGuidelines;